const app = {
	namespaced: true,
	state: {
		sidebar: {
			opened: true, //Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
			routes: []
		},
		navbar: {
			isShow: true,
			routes: []
		}
	},
	mutations: {
		TOGGLE_SIDEBAR(state) {
			state.sidebar.opened = !state.sidebar.opened
		}
	},
	actions: {
		toggleSideBar({ commit }) {
			commit('TOGGLE_SIDEBAR')
		}
	}
}

export default app
